// Main color is red[500]

export const red = {
    100: '#ffc2c8',
    500: '#FF5769',
    900: '#561314',
}

export const grey = {
    300: '#d8d8d8',
    400: '#ACB0B3',
    500: '#545454',
    900: '#474955',
}

export const green = {
    500: '#32B056',
}

export const white = {
    0: '#fff',
}
